import useLocalStorage from '../helper/use_local_storage';

export default function useVoting() {
  let [votesLocalStorage, setVotesLocalStorage] = useLocalStorage('votes', []);

  return [votesLocalStorage, setVotesLocalStorage as any];
}
